module.exports = __webpack_public_path__ + "static/media/loader_green.398c6da0.gif";